import { Component, OnInit, ViewChild, TemplateRef  } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators } from '@angular/forms'; 
import { department, division, user } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { UtilityService } from './../../../services/utility.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { element } from 'protractor';
import Swal from 'sweetalert2'
import { Router, ActivatedRoute, Params } from '@angular/router';
 

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit {
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  modalRef: BsModalRef;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;
  public title: string = 'Add';
  public data: any;
  searchText: string;
  dataSearch: any;
  public division_data: any;
  public user_data: any;
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
  public departmentData: object[];
  public orderForm: FormGroup;
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
 
  public permission: number = 1;
  user: any = {}; 
  login_UserID: string; // number

  isAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: AdminApiService, private modalService: BsModalService,private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.router.navigateByUrl('/access-denied');
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.loadDepartment();
    this.getDivisions();
    this.getUsers();
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    
    if (this.permission == 1) {
      this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search', 'ExcelExport'];
    }
    else
      this.toolbar = ['Search', 'ExcelExport'];
    
    this.pageSettings = { pageCount: 5 };
    this.filterSettings = { type: 'Excel' };
   // this.departmentData = DataUtil.distinct(this.data, 'id', true);

    
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'departmentCode', name: 'Code', field: 'departmentCode', sortable: true, maxWidth: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'departmentCode', 'departmentCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'departmentEn', name: 'Department Name', field: 'departmentEn', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'departmentEn', 'departmentEn'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'divisionName', name: 'Division', field: 'divisionName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'approverName', name: 'Approver', field: 'approverName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'approverName', 'approverName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'coordinatorName', name: 'Coordinator', field: 'coordinatorName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'coordinatorName', 'coordinatorName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', maxWidth: 75,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'edit_row', positionOrder: 62, title: 'Edit',

              iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                this.editItem(args.dataContext);
              }
            },



            {
              command: 'delete-row', titleKey: 'del_row', positionOrder: 65, title: 'Delete',
              iconCssClass: 'fa fa-trash fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteDepartment(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              }
            },


          ],
        }
      }

    ]


  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (this.permission == 1 )
      return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
    else
      return '';
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  // Get department list
  loadDepartment() {
    this.spinner.show();
    let inpValue = new department();  
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.data = data;
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            departmentCode: this.data[i].departmentCode,
            departmentEn: this.data[i].departmentEn,
            divisionName: this.data[i].divisionName,
            approverName: this.data[i].approverName,
            coordinatorName: this.data[i].coordinatorName,
            departmentAdminName: this.data[i].departmentAdminName,
            departmentUno: this.data[i].departmentUno,
            departmentAr: this.data[i].departmentAr,
            divisionUno: this.data[i].divisionUno,
            departmentCoordinatorUno: this.data[i].departmentCoordinatorUno,
            departmentAdminUno: this.data[i].departmentAdminUno,
            departmentApproverUno: this.data[i].departmentApproverUno
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      }); 
  }

  addItem() {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "add";
    this.submitClicked = false;

    this.title = 'Add Department';
    this.orderForm =  new FormGroup({
      departmentUno: new FormControl(0),
      departmentEn: new FormControl(null, Validators.required),
      departmentAr: new FormControl(null, Validators.required),
      departmentCode: new FormControl(null, Validators.required),
      divisionUno: new FormControl(null, Validators.required),
      departmentAdminUno: new FormControl(0),
      departmentCoordinatorUno: new FormControl(0),
      departmentApproverUno: new FormControl(0),
    });
  }

  editItem(data) {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "edit";
    this.submitClicked = false;
    this.title = 'Details of ' + data.departmentCode + ":" + data.departmentEn ;
    this.orderForm = this.createFormGroup(data)
  }
  saveDepartment(): void {
    this.submitClicked = true;
    if (this.orderForm.valid) {
      let data = this.orderForm.value;
      this.AddEditDepartment(data);
    }
    else {
      //Swal.fire('Error', 'Enter the required values', 'error');
      this.toaster.show('error', 'Error', 'Enter the required values.');
    }
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 4;
    inpValue.tenantUno = 1;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {        
        this.division_data = data;        
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getUsers() {

    let inpValue = new user();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 4;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {     
        this.user_data = data;     
        
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  createFormGroup(data1: any): FormGroup {
    //debugger;
    return new FormGroup({
      departmentUno: new FormControl(data1.departmentUno),
      departmentEn: new FormControl(data1.departmentEn, Validators.required),
      departmentAr: new FormControl(data1.departmentAr, Validators.required),
      departmentCode: new FormControl(data1.departmentCode, Validators.required),
      divisionUno: new FormControl(data1.divisionUno),
      departmentAdminUno: new FormControl(data1.departmentAdminUno.toString()),
      departmentCoordinatorUno: new FormControl(data1.departmentCoordinatorUno.toString()),
      departmentApproverUno: new FormControl(data1.departmentApproverUno.toString()),
    });
  }



  AddEditDepartment(data1: any) {

    if (this.orderForm.invalid) {
      //Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong.');
      return false;
    }

    if (this.utilityService.isNumericNull(data1.divisionUno) ==0) {
      //Swal.fire('Error', 'Division is required', 'error')
      this.toaster.show('error', 'Error', 'Division is required.');
      return false;
    }

    if (this.DuplicateNameCheck(this.utilityService.isStringNull(data1.departmentCode), this.utilityService.isNumericNull(data1.departmentUno)))
    {
      //Swal.fire('Error', 'Duplicates not allowed', 'warning');
      this.toaster.show('error', 'Error', 'Duplicates not allowed.');
      return false;
    }
    else {
      
      let objDepartment = new department();
      objDepartment.actionType = this.pageAction;
      objDepartment.departmentUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(data1.departmentUno);
      objDepartment.departmentEn = this.utilityService.isStringNull(data1.departmentEn);
      objDepartment.departmentAr = this.utilityService.isStringNull(data1.departmentAr);
      objDepartment.departmentCode = this.utilityService.isStringNull(data1.departmentCode);
      objDepartment.departmentAdminUno = this.utilityService.isNumericNull(data1.departmentAdminUno);
      objDepartment.divisionUno = this.utilityService.isNumericNull(data1.divisionUno);
      objDepartment.kPILastAutoId = 0;
      objDepartment.departmentCoordinatorUno = this.utilityService.isNumericNull(data1.departmentCoordinatorUno);
      objDepartment.departmentApproverUno = this.utilityService.isNumericNull(data1.departmentApproverUno);
      objDepartment.userUno = this.login_UserID;
      objDepartment.tenantUno = this.tenantUno;
      
      this.restApi.addEditDepartment(objDepartment)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '') {
            //Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
          }
          else {
            this.toaster.show('success', 'Success', 'Department saved.');
            //Swal.fire({
            //  type: 'success',
            //  title: 'Department saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.modalRef.hide();
            this.loadDepartment();
          }


          this.spinner.hide();
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      return true;
    }
  }

  DuplicateNameCheck(departmentCode: string,departmentUno:number) {
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        //  if (roles.some(role => role.includes(extLink.role))) {
        //    extLink.visible = true;
        //  }
        if (grdData.departmentCode.toLocaleLowerCase() == departmentCode.toLocaleLowerCase() && departmentUno != grdData.departmentUno)
         {
          rtnValue = true;
        }
      });

      return rtnValue;
    }
  }

  DeleteDepartment(data1: any) {

    let objDeaprtment = new department();
    objDeaprtment.actionType = this.pageAction;
    objDeaprtment.departmentUno =  data1.departmentUno;   
    objDeaprtment.userUno = this.login_UserID;
    objDeaprtment.tenantUno = 1;
    
    this.restApi.deleteDepartment(objDeaprtment)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'Department deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Department deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadDepartment();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
  


  get departmentEn(): AbstractControl { return this.orderForm.get('departmentEn'); }

  get departmentAr(): AbstractControl { return this.orderForm.get('departmentAr'); }

  get departmentCode(): AbstractControl { return this.orderForm.get('departmentCode'); }
  get divisionUno(): AbstractControl { return this.orderForm.get('divisionUno'); }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.departmentEn && a.departmentEn.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.divisionName && a.divisionName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.approverName && a.approverName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.coordinatorName && a.coordinatorName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.departmentAdminName && a.departmentAdminName.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
}
